import { CurrentUserAvatar } from "@facade/shared";
import { Typography } from "@facade/components/ui";
import { useSuspenseQuery } from "@tanstack/react-query";
import { userAttributesQueries } from "@facade/queries";

export const AccountInfo = () => {
  const { data: userAttributes } = useSuspenseQuery(
    userAttributesQueries.detail(),
  );

  return (
    <>
      <CurrentUserAvatar size="lg" />
      <div className="flex-1">
        <Typography className="leading-none">{userAttributes.email}</Typography>
        <Typography variant="text-muted">
          {"This is your personal account"}
        </Typography>
      </div>
    </>
  );
};
